import {
  Component,
  EventEmitter,
  Output
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { PatientOnboardDialogComponent } from '../patient-onboard-dialog/patient-onboard-dialog.component';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { RequisitionBuilderDialogComponent } from '../requisition-builder-dialog/requisition-builder-dialog.component';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MatDateFormats,
  NativeDateAdapter,
  MatNativeDateModule
} from '@angular/material/core';

export interface DashboardFilter {
  search: string;
  fromDate: Date;
  toDate: Date;
  isSearch: boolean;
}
export class AppDateAdapter extends NativeDateAdapter {

  override format(
    date: Date,
    displayFormat: Object
  ): string {

    if (displayFormat === 'input') {

      const day =
        ('00' + date.getDate()).slice(-2);

      const month =
        ('00' + (date.getMonth() + 1)).slice(-2);

      const year =
        date.getFullYear();

      return `${day}/${month}/${year}`;
    }

    return date.toDateString();
  }
}

export const APP_DATE_FORMATS: MatDateFormats = {

  parse: {
    dateInput: {
      month: 'short',
      year: 'numeric',
      day: 'numeric'
    }
  },

  display: {

    dateInput: 'input',

    monthYearLabel: {
      year: 'numeric',
      month: 'numeric'
    },

    dateA11yLabel: {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    },

    monthYearA11yLabel: {
      year: 'numeric',
      month: 'long'
    }
  }
};

@Component({
  selector: 'app-requisition-filter',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatIconModule
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: AppDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS
    }
  ],
  templateUrl: './requisition-filter.component.html',
  styleUrls: ['./requisition-filter.component.scss']
})
export class RequisitionFilterComponent {

  constructor(private dialog: MatDialog,) { }

  @Output()
  filterChange =
    new EventEmitter<DashboardFilter>();

  @Output()
  onboardPatient =
    new EventEmitter<void>();
  @Output()
  refreshDashboard = new EventEmitter<void>();

  @Output()
  createRequisition =
    new EventEmitter<void>();
  @Output()
  patientOnboarded = new EventEmitter<any>();


  search = '';

  fromDate = new Date(
    new Date().setDate(
      new Date().getDate() - 7
    )
  );

  toDate = new Date();
  searchSubject = new Subject<string>();

  ngOnInit(): void {

    this.searchSubject
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe(search => {

        if (search.length >= 4 || search.length === 0) {

          this.filterChange.emit({
            search,
            fromDate: this.fromDate,
            toDate: this.toDate,
            isSearch: search.length >= 4
          });

        }
      });
  }

  searchClick(): void {

    this.filterChange.emit({
      search: this.search,
      fromDate: this.fromDate,
      toDate: this.toDate,
      isSearch: !!this.search.trim()
    });

  }

  refresh(): void {

    this.search = '';

    this.fromDate = new Date(
      new Date().setDate(
        new Date().getDate() - 7
      )
    );

    this.toDate = new Date();

    this.filterChange.emit({
      search: '',
      fromDate: this.fromDate,
      toDate: this.toDate,
      isSearch: false
    });
  }

  onSearchChange(value: string): void {
    this.searchSubject.next(value?.trim() || '');
  }

  openPatientOnboard(): void {

    const dialogRef = this.dialog.open(
      PatientOnboardDialogComponent,
      {
        width: '900px',
        maxWidth: '95vw',

        height: '88vh',
        maxHeight: '88vh',

        panelClass: 'patient-onboard-dialog',

        autoFocus: false
      }
    );


    dialogRef.afterClosed()
      .subscribe((result: any) => {

        console.log(
          'ONBOARD AFTER CLOSED:',
          result
        );


        if (
          result?.openRequisition &&
          result?.patient
        ) {

          console.log(
            'OPENING REQUISITION:',
            result.patient
          );


          const requisitionRef =
            this.dialog.open(
              RequisitionBuilderDialogComponent,
              {
                width: '65vw',

                height: '99vh',

                panelClass:
                  'requisition-dialog-panel',

                disableClose: false,

                autoFocus: false,

                data: {

                  patient:
                    result.patient

                }

              }
            );


          requisitionRef.afterClosed()
            .subscribe((response: any) => {

              console.log(
                'REQUISITION CLOSED:',
                response
              );


              if (response?.refresh) {

                this.patientOnboarded.emit({
                  refresh: true
                });

              }

            });

        }

      });

  }
}